// extracted by mini-css-extract-plugin
module.exports = {"container":"ShiftCashier_container__2WIJO","container-ltr":"ShiftCashier_container-ltr__gqqik"};